import Customerview from "../components/customerview/cutomerview"
function Customervieww(){
    return(
        <>
        <Customerview/>
        </>
    )
}
export default Customervieww